import React, { useState } from "react";
import Search from "../components/Search";
import PropertyFilter from "../components/PropertyFilter";
import AOS from "aos"; // Import AOS library
import { fetchAPI } from "../helper/fetchAPI";
import PropertyList from "../components/PropertyList";
import * as constants from "../constants";
import NewLaunch from "../components/NewLaunch";
import News from "../components/News";
import ContactUsForm from "../components/ContactUsForm";
import { useLocation, useParams } from 'react-router-dom';
import Breadcrumb from "../components/Breadcrumb";
import DeveloperStartsFrom from "../components/DeveloperStartsFrom";
import { decodeId, deslugify, detectScript, encodeId, getDecodedPathParam, replacePathParams, slugify } from "../helper/helperFunction";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";
import FullScreenLoader from "../components/FullScreenLoader";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const PropertyListing = () => {
  const { developerName, projectName, idProject } = useParams();
  const { searchType } = useParams();

  const { i18n } = useTranslation();
  const countryPrefix = useCountryPrefix();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const Keyword = searchParams.get('q');
  const CityIds = searchParams.get('c');
  const DeveloperIds = searchParams.get('dv');
  const PropertyTypes = searchParams.get('pt');
  const BedCounts = searchParams.get('bec');
  const BathCounts = searchParams.get('bac');
  const Amenities = searchParams.get('a');
  const DeliveryYears = searchParams.get('dy');
  const ProjectStatuses = searchParams.get('p');
  const ProjectSales = searchParams.get('ps');
  const MinPrice = searchParams.get('mnp');
  const MaxPrice = searchParams.get('mxp');
  const MinAreaSize = searchParams.get('mns');
  const MaxAreaSize = searchParams.get('mxs');
  const ApplyFilters = true;



  const params = [];

  if (Keyword) params.push(`Search=${decodeURIComponent(Keyword)}`);
  if (CityIds) params.push(`Cities=${deslugify(CityIds)}`);
  // if (ProjectStatuses) params.push(`ProjectStatuses=${ProjectStatuses}`);
  if (ProjectStatuses) params.push(`ProjectStatuses=${Object.keys(constants.ProjectStatus).filter(id => ProjectStatuses.includes(constants.ProjectStatus[id].label)).map(id => Number(id))}`);
  if (ProjectSales) params.push(`SaleType=${Object.keys(constants.PropertySaleTypes).filter(id => ProjectSales.includes(constants.PropertySaleTypes[id].label)).map(id => Number(id))}`);
  if (DeveloperIds) params.push(`Developers=${deslugify(DeveloperIds)}`);
  if (DeliveryYears) params.push(`DeliveryYears=${DeliveryYears}`);
  if (BedCounts) params.push(`BedCounts=${BedCounts}`);
  if (BathCounts) params.push(`BathCounts=${BathCounts}`);
  if (MinPrice) params.push(`MinPrice=${MinPrice}`);
  if (MaxPrice) params.push(`MaxPrice=${MaxPrice}`);
  if (MinAreaSize) params.push(`MinAreaSize=${MinAreaSize}`);
  if (MaxAreaSize) params.push(`MaxAreaSize=${MaxAreaSize}`);
  // if (Amenities) params.push(`Amenities=${Amenities}`);
  if (Amenities) params.push(`Amenities=${Object.keys(constants.defaultAmenities).filter(id => Amenities.includes(constants.defaultAmenities[id].label)).map(id => Number(id))}`);
  // if (PropertyTypes) params.push(`PropertyTypes=${PropertyTypes}`);
  if (PropertyTypes) params.push(`PropertyTypes=${Object.keys(constants.defaultPropertyType).filter(id => PropertyTypes.includes(constants.defaultPropertyType[id].label)).map(id => Number(id))}`);


  if (params.length > 0) {
    params.push('ApplyFilters=true');
  }
  let apiUrl = process.env.REACT_APP_API_URL;
  let listingApiUrl = process.env.REACT_APP_API_URL;
  let filterApiUrl = process.env.REACT_APP_API_URL;

  const [propertiesSection, setPropertiesSection] = useState({
    items: [],
    totalPages: 1,
    pageIndex: 1,
    totalItems: 0
  });
  const [newLaunchSection, setNewLaunchSection] = useState();
  const [ourNewsSection, setOurNewsSection] = useState();
  const [contactDetails, setContactDetails] = useState();
  const [developerDetails, setDeveloperDetails] = useState();
  const [projectDetails, setProjectDetails] = useState();
  const [filterSection, setFilterSection] = useState();

  const isArabic = i18n.language === "ar";
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  let langUrl = process.env.REACT_APP_API_URL;


  const fetchData = async (pageIndex) => {
    try {

      const language = isArabic ? "ar" : "en";

      apiUrl = `${apiUrl}${constants.homepage}?language=${language}&region_id=${countryPrefix}`;
      const queryString = params.length ? `${params.join('&')}` : '';

      listingApiUrl = idProject ?
        `${listingApiUrl}${constants.developerprojectproperty}?language=${language}&region_id=${countryPrefix}&projectId=${decodeId(idProject)}&PageIndex=${pageIndex}&PageSize=9` :
        `${listingApiUrl}${constants.propertysearch}?language=${language}&region_id=${countryPrefix}&${queryString}&PageIndex=${pageIndex}&PageSize=9`

      const res = await fetchAPI(apiUrl, "Get");

      if (res?.status === 200) {
        const section = res.data.sections;
        setNewLaunchSection(section.find((item) => item.sectionId === "LaunchSection"));

        setOurNewsSection(section.find((item) => item.sectionId === "NewsSection"));
      }

      const resListing = await fetchAPI(listingApiUrl, "Get");
      if (resListing?.status === 200) {

        setPropertiesSection((prevData) => ({
          ...prevData,
          items: [...(prevData?.items || []), ...(resListing?.data?.items || [])],
          totalPages: resListing?.data?.totalPages ?? prevData.totalPages,
          pageIndex: resListing?.data?.pageIndex ?? prevData.pageIndex,
          totalItems: resListing?.data?.totalItems ?? prevData.totalItems,
        }));
        setContactDetails(resListing?.data?.contactDetails)
        setDeveloperDetails(resListing?.data?.developerDetails)
        setProjectDetails(resListing?.data?.projectDetails)

        setIsLoaded(true)
        setLoadingMore(false)
      } else {
        setIsLoaded(true)
      }

      filterApiUrl = `${filterApiUrl}${constants.searchfilters}?language=${language}&region_id=${countryPrefix}`

      const resFilter = await fetchAPI(filterApiUrl, "Get");
      if (resFilter?.status === 200) {
        //some logic after api call
        setFilterSection(resFilter?.data)

      }

      if (developerName !== undefined && projectName !== undefined && idProject !== undefined) {

        const currentUrl = window.location.href;
        let replacement = {};

        let convPathDeveloperName = getDecodedPathParam(currentUrl, "developers/:developerName/project/:projectName/:idProject", "developerName")
        let convPathprojectName = getDecodedPathParam(currentUrl, "developers/:developerName/project/:projectName/:idProject", "projectName")

        if ((language === "en" && detectScript(convPathDeveloperName) === "arabic" || detectScript(convPathprojectName) === "arabic") || (language === "ar" && detectScript(convPathDeveloperName) === "english" || detectScript(convPathprojectName) === "english")) {

          langUrl = `${langUrl}${constants.localization}?DeveloperName=${developerName}&ProjectName=${projectName}`
          const res = await fetchAPI(langUrl, "Get");

          const pattern = `${countryPrefix}${language === "ar" ? "/ar" : ""}/developers/:developerName/project/:projectName/:idProject`;
          replacement = {
            developerName: slugify(isArabic ? res.data.developerName.ar : res.data.developerName.en),
            ...(projectName ? { projectName: slugify(isArabic ? res.data.projectName.ar : res.data.projectName.en) } : null)

          }
          var newUrl = replacePathParams(currentUrl, pattern, replacement)

          window.history.replaceState({}, '', newUrl);
        }

      }


    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    AOS.init();

    fetchData(pageIndex);
  }, [pageIndex]);


  const handleLoadMore = () => {
    setLoadingMore(true)
    setPageIndex(prev => prev + 1);
  };

  //const pathName = ["Home", "Developer", "Property"];
  const pathLang = isArabic ? "/ar" : "";
  const pathName = [
    { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
    { name: t("developers"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/developers` },
    { name: developerDetails?.developerName || "", path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/developers/${slugify(developerDetails?.developerName)}/${encodeId((developerDetails?.developerId))}` },
    { name: projectDetails?.projectName || "" },
  ];

  if (!isLoaded) {
    return (
      <FullScreenLoader />
    )
  }

  return (
    <>
      {idProject ? (

        <>
          <CustomHelmet
            title={"Exclusive Real Estate Across Egypt"}
            desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
          />
          <Breadcrumb pathName={pathName}></Breadcrumb>
          <DeveloperStartsFrom companyName={`${projectDetails?.projectName}`} location={projectDetails?.location} priceStart={developerDetails?.minPrice || 0} priceEnd={developerDetails?.maxPrice || 0} developerLogo={developerDetails?.thumbnailImage} phone={contactDetails?.phone} whatsApp={contactDetails?.whatsApp}></DeveloperStartsFrom>
          <PropertyList
            propertyTypeData={[]}
            propertiesData={propertiesSection}
            developerDetailData={developerDetails}
            contact={contactDetails}
            isFilter={false}
            cssClass={"pt-4"}
            isUrlAppend={true}
            onLoadMore={handleLoadMore}
            loadingMore={loadingMore}
          />
          <News data={ourNewsSection || {}} />
          <ContactUsForm imgDiv={false} />
        </>
      ) : (
        <>
          <CustomHelmet
            title={"Exclusive Real Estate Across Egypt"}
            desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
          />
          <PropertyFilter />
          <Search cusStyle={"filter-section-inner"} filters={filterSection} />
          <PropertyList
            propertyTypeData={[]}
            propertiesData={propertiesSection}
            developerDetailData={developerDetails}
            contact={contactDetails}
            isFilter={false}
            isUrlAppend={true}
            onLoadMore={handleLoadMore}
            loadingMore={loadingMore}

          />
          <NewLaunch data={newLaunchSection || {}} />
          <News data={ourNewsSection || {}} />
          <ContactUsForm imgDiv={false} />
        </>
      )}


    </>
  );
};

export default PropertyListing;
